import React, { ReactElement, ReactNode } from 'react';
import { getGlobalWindowVariables } from 'utils/globalWindowVariables';
import { EmbeddedLoginErrorWithErrorCode as EmbeddedLoginErrorWithErrorCodeCore } from '@instinet-analytics/semantic-ui-components';
import { useReloadRequired } from 'embedded/api/hooks/useReloadRequired';
import { useDispatchSupportRequestAction } from 'app/contactSupport/store/dispatcher';

export default function EmbeddedLoginErrorWithErrorCode({
    prefix,
}: {
    prefix?: ReactNode;
}): ReactElement {
    const { errorCode, errorDetails } = getGlobalWindowVariables();
    const { onReloadClicked } = useReloadRequired();
    const dispatchSupportRequest = useDispatchSupportRequestAction();

    return (
        <EmbeddedLoginErrorWithErrorCodeCore
            errorCode={errorCode!}
            errorDetails={errorDetails}
            onReloadClicked={onReloadClicked}
            onContactSupportClicked={dispatchSupportRequest}
            prefix={prefix}
            title="Host could not authenticate to Indigo"
        />
    );
}
